import { render } from "./GameGrid.vue?vue&type=template&id=7d89574c"
import script from "./GameGrid.vue?vue&type=script&lang=js"
export * from "./GameGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__